import axios from "axios";
import { getLanguageByName, getLanguageNameFromUser } from "./language";

const extractUserFromResponse = (response, userId) => {
  const user = response?.data?.data;

  if (!user || typeof user !== "object") {
    return null;
  }

  if (userId && user._id && user._id !== userId) {
    return null;
  }

  return user;
};

export const fetchUserDetailsById = async (userId) => {
  if (!userId) return null;

  const token = localStorage.getItem("Authorization");
  const headers = token ? { Authorization: token } : {};

  const urls = [
    `${process.env.REACT_APP_BASE_URL}/public/user/details/${userId}/v1`,
    `${process.env.REACT_APP_BASE_URL}/user/details/${userId}/v1`,
    `${process.env.REACT_APP_BASE_URL}/details/v1?userId=${userId}`,
  ];

  if (token) {
    urls.unshift(`${process.env.REACT_APP_BASE_URL}/details/v1`);
  }

  for (const url of urls) {
    try {
      const response = await axios.get(url, { headers });
      const user = extractUserFromResponse(response, userId);

      if (user) {
        return user;
      }
    } catch (error) {
      // Try the next endpoint.
    }
  }

  return null;
};

export const getUserLanguageOption = (user) =>
  getLanguageByName(getLanguageNameFromUser(user));
